
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg svg-search",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.971 19.95a7.98 7.98 0 000-15.96 7.98 7.98 0 000 15.96zm9.708-.975l9.8 9.8a1.912 1.912 0 01-2.704 2.702l.001.001-9.8-9.8a11.876 11.876 0 01-7.004 2.263C5.361 23.941.001 18.581.001 11.97S5.361-.001 11.972-.001s11.971 5.36 11.971 11.971a11.92 11.92 0 01-2.287 7.039l.024-.034z"}})])
          )
        }
      }
    